import { handleActions } from 'redux-actions';
import { NotificationManager, __esModule} from "react-notifications";
import { push, goBack } from "react-router-redux";
import { api } from "api";

let url = 'permisos_especificos' ;
let url_cuentas = 'cuentas' ;


export const constants = {
    LOADER: `SET_LOADER`,
    DATA: `SET_DATA`,
    PAGE: `SET_PAGE`,
    ORDERING: `SET_ORDERING`
};

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});

const setData = (type, data) =>({
    type,
    data
})

const setPage = page => ({
    type: constants.PAGE,
    page,
});

// -----------------------------------
// Actions
// -----------------------------------

const listar = (page = 1, usuarioId=null) => (dispatch, getStore) => {
    const resource = getStore().permisosEspecificos;
    const me = getStore().login.me
    const params = { page };

    params.ordering = resource.ordering;
    if (resource.search) params.search = resource.search;
    params.cob = 1;
    params.usuarioId = usuarioId;

    dispatch(setLoader(true));
    api.get(`${url_cuentas}/permisos_cajas_chicas`, params).then((response) => {
        dispatch(setData(constants.DATA ,response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const guardar = (usuarioID) => (dispatch, getStore) =>{
    const resource = getStore().permisosEspecificos;
    let data = resource.data.results;
    dispatch(setLoader(true));
    api.put(`${url}/${usuarioID}/permiso_cajas_chicas_update`, data).then((response) => {
        NotificationManager.success(response.detail, 'Éxito', 3000);
        dispatch(goBack());
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const actions = {
    listar,
    guardar,
};

// -----------------------------------
// Reducers
// -----------------------------------

const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [constants.PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [constants.ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
};
const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
};
export default handleActions(reducers, initialState);